import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  card: theme => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    gap: ${theme.spacing.xxs};

    hr {
      width: 100%;
      height: 1px;
      border: 0;
      background-color: ${theme.colors.neutral[100]};
    }
  `,

  cardHeader: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `,

  nameWrapper: css`
    display: flex;
    flex-direction: column;

    p:last-child {
      align-self: flex-start;
    }
  `,

  specialtiesWrapper: theme => css`
    p {
      gap: ${theme.spacing.xxs};
      margin-bottom: ${theme.spacing.xxs};
    }
  `,

  link: css`
    cursor: pointer;
    width: fit-content;
  `,

  cardFooter: theme => css`
    width: 100%;
    display: flex;
    justify-content: center;

    span {
      margin-top: 2px;
    }

    svg {
      width: ${theme.spacing.xs};
    }
  `,
})

export { useStyles }
